<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex align-items-center justify-content-between"
            >
              <h4 class="card-title">{{ $t("message.menu.find_partner") }}</h4>
              <b-dropdown
                id="dropdown-1"
                :text="$t('message.view')"
                class="ml-auto m-md-2"
              >
                <b-dropdown-item @click="view = 'full'">{{
                  $t("message.full")
                }}</b-dropdown-item>
                <b-dropdown-item @click="view = 'compact'">{{
                  $t("message.compact")
                }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="card-body px-3">
              <b-tabs pills content-class="mt-3" small v-model="current_tab">
                <b-tab
                  :title="$t('message.find_partner.cn')"
                  active
                  id="search-tab"
                >
                  <template #title>
                    <img src="/flag/cn.png" style="margin-right: 10px" />
                    {{ $t("message.find_partner.cn") }}
                  </template>
                  <div class="d-flex">
                    <AllServicesCN :view="view" />
                    <!-- <div class="col-6"> -->
                    <!-- <div class="card"> -->
                    <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                    <!-- <div class="card-body"> -->
                    <!-- <h5 class="card-title">Card title</h5> -->
                    <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                    <!-- <div name="partners-nav-link"  class="nav-item">
														<router-link :to="{name: 'find-a-partner-index'}"  @click="show_menu = false" class="btn btn-outline-primary btn-lg text-nowrap">
															Экспортеры
														</router-link>
													</div> -->
                    <!-- <a href="#" class="btn btn-primary">Экспортеры</a> -->
                    <!-- </div> -->
                    <!-- </div> -->
                    <!-- </div> -->
                    <!-- <div class="col-6"> -->
                    <!-- <div class="card"> -->
                    <!-- <img class="card-img-top" src="..." alt="Card image cap"> -->
                    <!-- <div class="card-body"> -->
                    <!-- <h5 class="card-title">Card title</h5> -->
                    <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                    <!-- <div name="partners-nav-link"  class="nav-item">
														<router-link :to="{name: 'all-services-cn'}"  @click="show_menu = false" class="btn  ml-3 btn-outline-primary btn-lg text-nowrap">
															Все услуги
														</router-link>
													</div> -->
                    <!-- </div> -->
                    <!-- </div> -->
                    <!-- </div> -->
                  </div>
                </b-tab>
                <!-- <b-tab :title="$t('message.find_partner.kz')" lazy id="case-management-tab" disabled>
									<template #title>
										<img src="/flag/kz.png" style="margin-right: 10px;"/> {{$t('message.find_partner.kz')}}
									</template>
                                </b-tab>
                                <b-tab :title="$t('message.find_partner.ru')" lazy id="case-management-tab"  disabled>
							        <template #title>
										<img src="/flag/ru.png" style="margin-right: 10px;"/> {{$t('message.find_partner.ru')}}
									</template>
                                </b-tab> -->
                <b-tab>
                  <template #title>
                    <i class="fa fa-history"></i>
                    {{ $t("message.find_partner.history") }}
                  </template>
                  <contragent-seatch-history />
                </b-tab>
              </b-tabs>
              <h3>
                Сервис поиска контрагента в Китае и проверка его на
                благонадежность
              </h3>

              <p>
                Сервис предназначен для поиска и проверки контрагентов в Китае в
                режиме реального времени. Поиск и проверка осуществляются по
                базам данных регистраторов, контролирующих органов, а также СМИ
                в Китае.
              </p>
              <ul>
                <li>
                  Сервис поиска контрагента позволяет найти компанию на
                  территории Китая (включая Гонконг и Тайвань) по множеству
                  параметров, таких, как название компании, имя человека,
                  название продукта, адрес, телефон, сфера деятельности и т. д..
                  Текст вводится на русском, английском или китайском языках. В
                  результате Вы получите перечень компаний, который будет
                  включать наименование, кредитный код, регистрационный номер,
                  имя представителя, зарегистрированный адрес и статус
                  функционирования.
                </li>
              </ul>
              <p>
                Сервис осуществляет автоматический перевод введенных критериев
                на английский язык с предварительным показом Вам результата
                перевода на экран.
              </p>
              <p>
                Список компаний, выбранных Сервисом на основании заданных
                критериев, выводится постранично по 50 компаний.
              </p>
              <p>
                Вы можете получить расширенную бизнес-справку, содержащую
                деловую и отраслевую информацию о каждой компании из списка,
                нажав указателем курсора на соответствующую кнопку в строке
                вывода общих сведений.
              </p>
              <p>
                В результате Вы получите отчет, содержащий следующие сведения :
              </p>
              <ul>
                <li>
                  Название предприятия, статус регистрации, уставный капитал,
                  единый код социального кредита, тип предприятия, период
                  деятельности, численность персонала, юридический адрес, сфера
                  деятельности.
                </li>
                <li>
                  Зарегистрированные акционеры, ключевой персонал, иностранные
                  инвестиции компании, записи об изменениях, управляющие
                  компании, филиалы, головные офисы, контактные телефоны,
                  контактные адреса электронной почты.
                </li>
                <li>
                  Детальные сведения (включая деловые интервью, информацию об
                  акционерах (включая соотношение долей), ключевой персонал,
                  филиалы, информацию об изменениях, отраслевую классификацию,
                  корпоративные портреты и т. д.), так и информация, связанная с
                  корпоративными рисками, такими как административное наказание,
                  неправомерные деловые операции, недобросовестные лица,
                  подлежащие исполнению, лица, подлежащие исполнению, ипотека
                  движимого имущества, ликвидация, залог акций, выборочная
                  проверка, налоговый кредит и другая информация.
                </li>
                <li>
                  Годовой отчет компании, включающий в себя основную информацию,
                  заявленную самой компанией, информацию о веб-сайте или
                  интернет-магазине, информацию о спонсорах и вкладах в капитал,
                  информацию о состоянии корпоративных активов и изменениях в
                  капитале и т. д.
                </li>
                <li>
                  Собственные новости компании и общественное мнение, с
                  классификацией эмоционального типа новостей.
                </li>
                <li>
                  Сведения судебных решений с регистрационным номером дела,
                  типом решения, государственный орган, истец, ответчик и другие
                  сведения.
                </li>
              </ul>
              <p>
                Сервис позволяет выводить полученные сведения в файл pdf формата
                для возможности последующей печати.
              </p>
              <p>
                Сервис осуществляет автоматический перевод сведений с китайского
                языка на русский с одновременным выводом на экран, как на
                русском, так и на китайском языках.
              </p>
              <p>
                Все результаты поиска сохраняются в Вашем Личном кабинете. Вы
                можете получить доступ к сохраненным результатам, как для
                повторного просмотра, так и для вывода на печать.
              </p>
              <p>
                Сервис производит автоматическую тарификацию предоставления
                услуги, с контролем достаточности денежных средств на Вашем
                системном счете. Перед выполнением каждого запроса Сервис
                выводит на экран стоимость услуги и предлагает Вам подтвердить
                свое согласие на ее оплату.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import AllServicesCN from "./all-services-CN.vue";
export default {
  data() {
    return {
      current_tab: 0,
      view: "full",
    };
  },
  mounted() {},
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
  },
  components: { AllServicesCN },
};
</script>
